import Pager from './Pager'
import PagerContainer from './PagerContainer'
export default PagerContainer(Pager)
